// extracted by mini-css-extract-plugin
export var badge = "SelectDebitCardStep-module--badge--553a7";
export var buttonSkeleton = "SelectDebitCardStep-module--buttonSkeleton--f56ac";
export var container = "SelectDebitCardStep-module--container--d6e3a";
export var expired = "SelectDebitCardStep-module--expired--4b2e5";
export var lastUsed = "SelectDebitCardStep-module--lastUsed--3b13d";